export enum Scripts {
    Adobe = 'adobe',
    Config = 'config',
    UpdateBillingSdk = 'update-billing-sdk',
    Consent = 'consent'
}